import React from 'react';
import Icon from '../icon';
import { 
  TransitionMotion as Transition,
  spring 
} from 'react-motion';

const RIGHT = 'right';
const LEFT = 'left';

class carousel extends React.Component {
  constructor (props) {
    super (props);

    this.hasImage = this.hasImage.bind (this);
    this.setImage = this.setImage.bind (this);
    this.nextImage =  this.nextImage.bind (this);
    this.prevImage = this.prevImage.bind (this);
    this.willLeave = this.willLeave.bind (this);
    this.willEnter = this.willEnter.bind (this);

    this.state = {
      active: 0,
      scrollDirection: null
    }
  }

  hasImage (imageNum = 0) {
    return this.props.images && this.props.images.length > imageNum;
  }

  setImage (imageIndex, scrollDirection) {
    this.setState ({
      active: imageIndex,
      scrollDirection: scrollDirection
    });
  }

  prevImage () {
    let active = this.state.active;
    active = active > 0 ? active - 1 : this.props.images.length - 1;
    this.setImage (active, LEFT);
  }

  nextImage () {
    let active = this.state.active;
    active = this.hasImage (active + 1) ? active + 1 : 0;
    this.setImage (active, RIGHT);
  }

  willLeave (styleThatLeft) {
    return this.state.scrollDirection === RIGHT ?
      { transform: spring (-100), opacity: spring (0) } :
      { transform: spring (100), opacity: spring (0) };
  } 

  willEnter (styleThatEntered) {
    return this.state.scrollDirection === RIGHT ?
      { transform: 100, opacity: 0 } :
      { transform: -100, opacity: 0 };
  }

  render () {
    let currentImage = {
      key: `${this.state.active}`,
      style: {
        transform: spring (0),
        opacity: spring (1)
      }
    }

    return (
      <div className="carousel" >
        <Transition 
          willLeave={this.willLeave}
          willEnter={this.willEnter}
          styles={[currentImage]}
        >
        {interpolateStyles => 
          <div className="carousel--image-container">
            { interpolateStyles.map (item => {
              var containerStyle = {
                transform: `translateX(${item.style.transform}%)`,
                opacity: item.style.opacity
              }
              return (
                <div 
                  className="carousel--image-display"
                  style={containerStyle}
                  key={item.key}
                >
                  <img 
                    src={this.props.images [parseInt (item.key)]} 
                    className="carousel--image"
                  />
                </div>
              )})
            }
          </div>
        }
        </Transition>
        <div className="carousel--controls-container">
          <Icon 
            symbol={Icon.SYMBOL.LEFT} 
            viewBox="0 0 32 100"
            className="carousel--back-button"
            onClick={this.prevImage}
          />
          <span className="carousel--number">
            {this.state.active + 1}/{this.props.images.length}
          </span>
          <Icon 
            symbol={Icon.SYMBOL.RIGHT}
            viewBox="0 0 32 100"
            className="carousel--next-button"
            onClick={this.nextImage}
          />
        </div>
      </div>
    )
  }
}

export default carousel;


// WEBPACK FOOTER //
// ./components/carousel/index.js